import { Component, OnInit, ViewChild } from '@angular/core';
import { AuditLogService } from '../../services/audit-log.service';
import { AuditLog } from '../../models/audit-log';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { ColDef, RowSelectionOptions } from 'ag-grid-community';
import { AuditChangesButtonComponent } from './audit-changes-button.component';
import { OrganizationService } from '../../services/organization.service';
import { Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-audit-logs',
  imports: [FormsModule, AgGridModule],
  templateUrl: './audit-logs.component.html',
  styleUrl: './audit-logs.component.scss'
})
export class AuditLogsComponent implements OnInit {

  private readonly _destroying$ = new Subject<void>();

  auditLogs: AuditLog[] = [];
  loading: boolean = true;
  filters = { entity: '', user: '', dateRange: null };

  selectedJsonData: string = '';

  columnDefs: ColDef<AuditLog>[] = [
    { field: 'entityName', headerName: 'Entity', sortable: true, filter: true },
    { field: 'operation', headerName: 'Operation', sortable: true, filter: true, cellRenderer: this.operationCellRenderer },
    { field: 'changedBy', headerName: 'Changed By', sortable: true, filter: true },
    { field: 'changedDate', headerName: 'Date', sortable: true, filter: 'agDateColumnFilter', valueFormatter: (params: { value: string | number | Date; }) => new Date(params.value).toLocaleString() },
    { field: 'id', headerName: 'Details', autoHeight: true, cellRenderer: AuditChangesButtonComponent },
  ];

  defaultColDef = { resizable: true, flex: 1 };


  constructor(private auditLogService: AuditLogService, private organizationService: OrganizationService) { }

  ngOnInit() {
    this.loadAuditLogs();


    //subscribe to changes on the organization id (dropdown / service)
    this.organizationService.organizationId$
      .pipe(takeUntil(this._destroying$))
      .subscribe(() => {
        this.loadAuditLogs();
      });

  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  loadAuditLogs() {
    this.loading = true;
    this.auditLogService.getAuditLogs(this.filters).subscribe({
      next: logs => {
        this.auditLogs = logs;
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }

  getOperationClass(operation: string): string {
    return {
      'Added': 'badge-success',
      'Modified': 'badge-warning',
      'Deleted': 'badge-danger'
    }[operation] || 'badge-secondary';
  }

  operationCellRenderer(params: any): string {
    const colors: Record<string, string> = {
      Added: 'green',
      Modified: 'orange',
      Deleted: 'red'
    };
    return `<span style="color:${colors[params.value] || 'black'}">${params.value}</span>`;
  }


}
